import React, { CSSProperties } from 'react';

type Props = {
  style?: CSSProperties;
  fill?: string;
  width?: string | number;
  className?: string;
  viewBox?: string;
};

const SVG: React.FC<Props> = ({
  style = {},
  fill = '#69005b',
  width = '100%',
  className = '',
  viewBox = '0 0 86.953 86.957',
}) => (
  <svg
    width={width}
    style={style}
    height={width}
    viewBox={viewBox}
    xmlns="http://www.w3.org/2000/svg"
    className={`svg-icon ${className || ''}`}
    xmlnsXlink="http://www.w3.org/1999/xlink"
  >
    <path
      id="sun-solid"
      className="icon"
      d="M43.478,27.174a16.3,16.3,0,1,0,16.3,16.3A16.33,16.33,0,0,0,43.478,27.174ZM85.326,40.846,69.243,32.813l5.69-17.052a2.937,2.937,0,0,0-3.719-3.719l-17.052,5.69-8.05-16.1a2.94,2.94,0,0,0-5.265,0L32.813,17.714l-17.069-5.69a2.937,2.937,0,0,0-3.719,3.719L17.714,32.8,1.63,40.846a2.94,2.94,0,0,0,0,5.265l16.084,8.033-5.69,17.069a2.937,2.937,0,0,0,3.719,3.719L32.8,69.243l8.033,16.084a2.94,2.94,0,0,0,5.265,0l8.033-16.084,17.052,5.69A2.937,2.937,0,0,0,74.9,71.213l-5.69-17.052,16.084-8.033a2.944,2.944,0,0,0,.034-5.282Zm-26.478,18a21.737,21.737,0,1,1,0-30.741A21.762,21.762,0,0,1,58.849,58.849Z"
      fill={fill}
    />
  </svg>
);

export default SVG;
